import { render, staticRenderFns } from "./PrintOrder.vue?vue&type=template&id=5045ed8f&scoped=true&"
import script from "./PrintOrder.vue?vue&type=script&lang=js&"
export * from "./PrintOrder.vue?vue&type=script&lang=js&"
import style0 from "./PrintOrder.vue?vue&type=style&index=0&id=5045ed8f&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5045ed8f",
  null
  
)

export default component.exports